import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import { GetUserFullName, useGetPathProtocol } from 'helpers';
import { TE } from 'appconstants';
import { StudyChampionsColumns } from '../gridcolumns';

const StudyChampions = ({ data }) => (
  <GridTable
    tag={`${TE.ID}studychampions${TE.TABLE}`}
    title="Study Champions"
    exportTitle={`Study Champions-${useGetPathProtocol()}-Participation`}
    columns={StudyChampionsColumns}
    user={GetUserFullName()}
    rows={data}
    editable
    deletable
    filterable
    sortable
    enableToolbar
    defaultSorts={[{
      field: 'ctepId',
      dir: 'asc'
    }]}
    toPdf={false}
  />
);

export { StudyChampions };
